import React, {Component} from 'react'
import withSelectFetch from './withSelectFetch'
import withSpinning from '../HOC/withSpinning'
import {compose} from 'recompose'
import withSort from '../HOC/withSort'
import CustomSelect from './CustomSelect'

class Tag extends Component {
  render() {
    return <CustomSelect {...this.props} keyAtr={'value'} valueAtr={'value'} />
  }
}

const TagSelect = compose(
  withSelectFetch({dropdown: 'general', name: 'tag'}),
  withSpinning,
  withSort,
)(Tag)
export default TagSelect
